import { useLocation, useParams, useNavigate } from 'react-router-dom';

export function withRouter(Component) {
    function ComponentWithRouterProp(props) {
        let location = useLocation();
        let navigate = useNavigate();
        let params = useParams();

        const match = {
            path: location.pathname,
            params: params,
            url: location.pathname
        };

        return (
            <Component
                {...props}
                match={match}
                navigate={navigate}
                location={location}
            />
        );
    }

    return ComponentWithRouterProp;
}